export enum paymentMethod {
    DebitOrder = "DebitOrder",
    CatholicWallet = "CatholicWallet"
}